import React, { useState, useEffect, useCallback, Suspense } from 'react';
import { useLocation } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { motion } from 'framer-motion';
import styles from './Contacto.module.scss';
import PageFooter from '../components/PageFooter';
import ModeloDestacado from '../components/ModeloDestacado/ModeloDestacado';

const LazyPageBanner = React.lazy(() => import('../components/PageBanner'));
const LazyContactCard = React.lazy(() => import('../components/Contacto/ContactCard'));
const LazyContactMap = React.lazy(() => import('../components/Contacto/ContactMap'));

const Contacto = () => {
  const location = useLocation();
  const modelo = location.state?.modelo || null;
  const [selectedOficina, setSelectedOficina] = useState(null);

  // Scroll to top on mount
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleOfficeChange = useCallback((oficina) => {
    console.log('Cambio de oficina:', oficina);
    setSelectedOficina(oficina);
  }, []);

  // Cuando selectedOficina deja de ser null, lanzamos la animación
  const cardReady = selectedOficina !== null;

  return (
    <>
      <Helmet>
        <title>Zoomlion Latinoamérica | Contacto</title>
        <meta
          name="description"
          content="Conoce las oficinas y centros de atención de Zoomlion en Latinoamérica y ponte en contacto con nosotros."
        />
      </Helmet>

      <div className={styles.page}>
        <div className={styles.banner}>
          <Suspense fallback={<div>Cargando Banner...</div>}>
            <LazyPageBanner modelo={modelo} />
          </Suspense>
        </div>

        <div className={styles.content}>
          <div className={styles.info}>
            <motion.div
              className={styles.card}
              initial={{ x: -100, opacity: 0 }}
              animate={cardReady ? { x: 0, opacity: 1 } : {}}
              transition={{ duration: 0.6, ease: 'easeOut' }}
            >
              <Suspense fallback={<div>Cargando Oficinas...</div>}>
                <LazyContactCard onOfficeChange={handleOfficeChange} />
              </Suspense>
            </motion.div>

            <motion.div
              className={styles.map}
              initial={{ y: 20, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              transition={{ duration: 0.6, delay: 0.2, ease: 'easeOut' }}
            >
              <Suspense fallback={<div>Cargando Mapa...</div>}>
                <LazyContactMap oficina={selectedOficina} />
              </Suspense>
            </motion.div>
          </div>
        </div>
        <ModeloDestacado />

        <div className={styles.footer}>
          <PageFooter />
        </div>
      </div>
    </>
  );
};

export default Contacto;
